import { getBaseFeature } from '@/assets/style/variable'

const styObj = {
  default: {
    '--wds-page-bg': '#eeeef1',
    '--wds-accent-color': '#a338fc',
    '--wds-change-btn-bg': '#a338fc',
    '--wds-change-btn-color': '#ffffff',
    '--wds-finish-icon': `url(${require('@/assets/packageAssets/views/P1_Girls/WithdrawalDetails/default/finish.webp')})`,
  },

  kiko: {
    '--wds-page-bg': '#eeeef1',
    '--wds-accent-color': '#b79b21',
    '--wds-change-btn-bg': '#ffe242',
    '--wds-change-btn-color': '#000000',
    '--wds-finish-icon': `url(${require('@/assets/packageAssets/views/P1_Girls/WithdrawalDetails/default/finish-kiko.webp')})`,
  },
}

export const pageCssVars = {
  methods: {
    cssVars() {
      if (this.packageName) {
        if (styObj[this.packageName]) {
          return { ...getBaseFeature(), ...styObj[this.packageName] }
        }
        return { ...getBaseFeature(), ...styObj.default }
      }
      return { ...getBaseFeature() }
    },
  },
}
